import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Policies.css';

const FAQ: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="policy-container">
      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <h1>Frequently Asked Questions</h1>

      <section className="policy-section">
        <h2>General Questions</h2>

        <div className="faq-item">
          <h3>What is Fervoir?</h3>
          <p>Fervoir is a modern dating platform where you can discover new people, match based on preference, and chat safely.</p>
        </div>

        <div className="faq-item">
          <h3>How do matches work?</h3>
          <p>When two users like each other, it becomes a match and you can start chatting instantly.</p>
        </div>

        <div className="faq-item">
          <h3>Is Fervoir free?</h3>
          <p>Yes, basic features are free. Premium features may be added in the future.</p>
        </div>

        <div className="faq-item">
          <h3>How do I report a user?</h3>
          <p>You can report or block any user directly from their profile or conversation screen.</p>
        </div>

        <div className="faq-item">
          <h3>Can I delete my account?</h3>
          <p>Yes. Go to Settings → Account → Delete Account. All your data will be removed permanently.</p>
        </div>

        <div className="faq-item">
          <h3>How do I edit my profile?</h3>
          <p>Go to Profile → Edit Profile to update photos, bio, interests, and preferences.</p>
        </div>

        <div className="faq-item">
          <h3>Can someone see my location?</h3>
          <p>No. Fervoir only shows an approximate distance, not your exact location.</p>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
